import type { JSX } from 'react';
import { styled } from 'styled-components';
import { Icon } from '../Icon';
import { Text } from '../Text';
import { getColorScheme } from '../../private/helpers/getColorScheme';

export type DataCardTrendProps = {
  /**
   * Direction of the trend arrow
   */
  direction?: 'down' | 'up';
  /**
   * Outlook of the trend arrow
   */
  outlook?: 'negative' | 'positive';
  /**
   * Content to display next to the trend arrow
   */
  children: JSX.Element | string;
};

const StyledDataCardTrend = styled.div<{ $outlook: DataCardTrendProps['outlook'] }>`
  ${({ $outlook }) => getColorScheme($outlook === 'positive' ? 'success' : 'error')};
  background: var(--wui-color-bg-app);
  border-radius: var(--wui-border-radius-rounded);
  padding: var(--wui-space-01);
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const DataCardTrend = ({
  direction = 'up',
  outlook = 'positive',
  children,
  ...props
}: DataCardTrendProps): JSX.Element => {
  return (
    <StyledDataCardTrend $outlook={outlook}>
      <Icon
        size="md"
        type={direction === 'up' ? 'arrow-up' : 'arrow-down'}
        {...props}
      />
      <Text
        prominence="secondary"
        variant="label4"
      >
        {children}
      </Text>
    </StyledDataCardTrend>
  );
};
